


const Footer = () => {
  return (
    <div className="footer">
      Created with ❤️ by &nbsp;
      <a href="https://www.linkedin.com/in/ashutosh-shukla-451183199/" target="_blank" title="Ashutosh's Linkedin Profile">
        Ashutosh shukla 🚀🚀
      </a>
      
    </div>
  );
};

export default Footer;